export const ContentTypeSlugs = {
  Video: 'video/mp4',
};
